import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class PushMessageConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getBlockDays(): number {
		return this.configService.get((x) => x.matCommonUi.pushMessage?.blockDays, 365);
	}

	getCloseDays(): number {
		return this.configService.get((x) => x.matCommonUi.pushMessage?.closeDays, 1);
	}

	getCloseTime(): string {
		return this.configService.get((x) => x.matCommonUi.pushMessage?.closeTime, "6:00:00");
	}

	getDisabledRoutes(): string[] {
		return this.configService.get((x) => x.matCommonUi.pushMessage?.disabledRoutes, []);
	}
}
